//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export const PAGINATION_OPTIONS = [8, 16, 32, 64];

export const DEFAULT_PAGE_SIZE = 8;

export const DEFAULT_GALLERY_PAGE_SIZE = 12;

export const DEFAULT_PAGE_NUMBER = 0;

// TODO: PD-259928 - Support Sorting on the backend to remove page size limits.
export const MAX_PAGE_SIZE = 2200;

export const CAMPAIGN_CREATORS_LIST_PAGE_SIZE = 5000;
